module.exports = __webpack_public_path__ + "static/img/google-play-btn.a1e1afc.png";